export default __webpack_public_path__ + "static/hedgehogBookCoverBack-7123e6fd7f42417321af4c890caee59b.jpg";